const AttributeTypes = Object.freeze({
  DropDown: 1,
  CheckBox: 2,
  OptionalDropdown: 3,
})

export default AttributeTypes
